import React from 'react';
import { Button, RadioGroup, Typography } from '@telus-uds/components-web';
import { Formik, Form, Field } from 'formik';
import { getStepOneSchema } from './schema';
import { useTranslationsContext } from '../context/TranslationsContext';
import ErrorIcon from '../../assets/images/icon_error_messages.gif';
import { channelFields } from '../utils/index';
import { useFormikScrollToError } from '../utils/utils';

const StepOne = ({
  onSubmit,
  stepData: {
    legalBusinessName,
    firstName,
    lastName,
    email,
    mobileNumber,
    // bestTimeofDayToContact,
    prefferedLanguage,
    province,
    existingTelusAccount,
    businessAccountNumber
  },
  role
}) => {
  const translations = useTranslationsContext();
  const {
    REFERRALS: {
      stepOne: { labels, errorLabels }
    }
  } = translations;
  // const [morning, afternoon, evening] = labels.timeOfDayOptions;
  const [english, french] = labels.preferredLanguageOptions;
  const [
    BC,
    AB,
    SK,
    MB,
    ON,
    QC,
    ATL,
    NB,
    NS,
    PEI,
    NFL
  ] = labels.provinceOptions;
  const [yes, no] = labels.existingTelusAccountOptions;
  const pageKey = 'customerInformation';
  return (
    <Formik
      validationSchema={getStepOneSchema(errorLabels, channelFields(pageKey))}
      validateOnBlur={false}
      validateOnChange={false}
      onSubmit={onSubmit}
      initialValues={{
        legalBusinessName: legalBusinessName || '',
        firstName: firstName || '',
        lastName: lastName || '',
        email: email || '',
        mobileNumber: mobileNumber || '',
        // bestTimeofDayToContact: bestTimeofDayToContact || '',
        prefferedLanguage: prefferedLanguage || '',
        province: province || '',
        existingTelusAccount: existingTelusAccount || '',
        businessAccountNumber: businessAccountNumber || ''
      }}
    >
      {({ errors, touched, values, setFieldValue, isValidating, isSubmitting, handleSubmit }) => (
        <>
          {useFormikScrollToError(isSubmitting, isValidating, errors)}
          <Form>
            <div className="main-content-form-headers" style={{ marginTop: 20 }}>
              <Typography block heading="h4" variant={{ size: 'h4' }}>
                {labels.businessLegalName}*
              </Typography>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.legalBusinessName && touched.legalBusinessName
                ? 'error'
                : ''
                }`}
            >
              <Field
                name="legalBusinessName"
                type="text"
                className="select-style"
                placeholder={labels.businessLegalName}
              />
              <>
                <div className="error_messages">
                  <Typography>
                    {errors.legalBusinessName}
                  </Typography>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>
            <div className="main-content-form-headers" style={{ marginTop: 20 }}>
              <Typography block heading="h4" variant={{ size: 'h4' }}>{labels.firstName}*</Typography>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.firstName && touched.firstName ? 'error' : ''
                }`}
            >
              <Field
                name="firstName"
                type="text"
                className="select-style"
                placeholder={labels.firstName}
              />
              <>
                <div className="error_messages">
                  <Typography>{errors.firstName}</Typography>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>
            <div className="main-content-form-headers" style={{ marginTop: 20 }}>
              <Typography block heading="h4" variant={{ size: 'h4' }}>{labels.lastName}*</Typography>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.lastName && touched.lastName ? 'error' : ''
                }`}
            >
              <Field
                name="lastName"
                type="text"
                className="select-style"
                placeholder={labels.lastName}
              />
              <>
                <div className="error_messages">
                  <Typography>{errors.lastName}</Typography>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>
            <div className="main-content-form-headers" style={{ marginTop: 20 }}>
              <Typography block heading="h4" variant={{ size: 'h4' }}>{labels.email}*</Typography>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.email && touched.email ? 'error' : ''
                }`}
            >
              <Field
                name="email"
                type="text"
                className="select-style"
                placeholder={labels.email}
              />
              <>
                <div className="error_messages">
                  <Typography>{errors.email}</Typography>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>
            <div className="main-content-form-headers" style={{ marginTop: 20 }}>
              <Typography block heading="h4" variant={{ size: 'h4' }}>{labels.mobileNumber}*</Typography>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.mobileNumber && touched.mobileNumber ? 'error' : ''
                }`}
            >
              <Field
                name="mobileNumber"
                type="text"
                className="select-style"
                placeholder={labels.mobileNumber}
              />
              <>
                <div className="error_messages">
                  <Typography>
                    {errors.mobileNumber}
                  </Typography>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>
            {/* <div className="main-content-form-headers" style={{ marginTop: 20 }}>
            <span className="select-placeholder"><Typography>{labels.bestTimeOfDay}</Typography></span>
          </div>
          <div
            style={{ position: 'relative' }}
            className={`input-container ${
              errors.bestTimeofDayToContact && touched.bestTimeofDayToContact
                ? 'error'
                : ''
            }`}
          >
            <label style={{ display: 'flex' }}>
              <Field
                name="bestTimeofDayToContact"
                as={Radio}
                type="radio"
                value="morning"
                className="select-style"
              />{' '}
              {morning}
            </label>
            <label style={{ display: 'flex' }}>
              <Field
                name="bestTimeofDayToContact"
                type="radio"
                as={Radio}
                value="afternoon"
                className="select-style"
              />{' '}
              {afternoon}
            </label>
            <label style={{ display: 'flex' }}>
              <Field
                name="bestTimeofDayToContact"
                type="radio"
                as={Radio}
                value="evening"
                className="select-style"
              />{' '}
              {evening}
            </label>
            <label>
              <div>
                <span className="frg-body-font-16px warning-error-message">
                  {errors.bestTimeofDayToContact}
                </span>
              </div>
            </label>
          </div> */}
            <div style={{ marginBottom: '20px', marginTop: '20px' }}>
              <RadioGroup
                legend={`${labels.prefferedLanguage}*`}
                items={[
                  { label: english, id: 'english' },
                  { label: french, id: 'french' }
                ]}
                checkedId={values.prefferedLanguage || null}
                onChange={(value) => setFieldValue('prefferedLanguage', value)}
                name="prefferedLanguage"
                validation={errors.prefferedLanguage && touched.prefferedLanguage ? 'error' : undefined}
                feedback={errors.prefferedLanguage && touched.prefferedLanguage ? errors.prefferedLanguage : undefined}
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <RadioGroup
                legend={`${labels.province}*`}
                items={[
                  { label: BC, id: BC },
                  { label: AB, id: AB },
                  { label: SK, id: SK },
                  { label: MB, id: MB },
                  { label: ON, id: ON },
                  { label: QC, id: QC },
                  { label: ATL, id: ATL },
                  { label: NB, id: NB },
                  { label: NS, id: NS },
                  { label: PEI, id: PEI },
                  { label: NFL, id: NFL }
                ]}
                checkedId={values.province || null}
                onChange={(value) => setFieldValue('province', value)}
                name="province"
                validation={errors.province && touched.province ? 'error' : undefined}
                feedback={errors.province && touched.province ? errors.province : undefined}
              />
            </div>
            {channelFields(pageKey) && (
              <div style={{ marginBottom: '20px' }}>
                <RadioGroup
                  legend={labels.existingTelusAccount}
                  items={[
                    { label: yes, id: 'Yes' },
                    { label: no, id: 'No' }
                  ]}
                  checkedId={values.existingTelusAccount || null}
                  onChange={(value) => setFieldValue('existingTelusAccount', value)}
                  name="existingTelusAccount"
                  validation={errors.existingTelusAccount && touched.existingTelusAccount ? 'error' : undefined}
                  feedback={errors.existingTelusAccount && touched.existingTelusAccount ? errors.existingTelusAccount : undefined}
                />
              </div>
            )}
            {values.existingTelusAccount === 'Yes' && (
              <>
                <div className="main-content-form-headers">
                  <Typography block heading="h4" variant={{ size: 'h4' }}>
                    {`${labels.businessAccountNumber} (if known)`}
                  </Typography>
                </div>
                <div
                  style={{ position: 'relative' }}
                  className={`input-container ${errors.businessAccountNumber && touched.businessAccountNumber
                    ? 'error'
                    : ''
                    }`}
                >
                  <Field
                    name="businessAccountNumber"
                    type="text"
                    className="select-style"
                    placeholder={labels.businessAccountNumber}
                  />
                  <>
                    <div className="error_messages">
                      <Typography>
                        {errors.businessAccountNumber}
                      </Typography>
                    </div>
                    <div id="username_error_icon" className="error_messages_icon">
                      <img src={ErrorIcon} alt="error_icon" />
                    </div>
                  </>
                </div>
              </>
            )}
            <div style={{ marginVertical: '20px' }}>
              <Button
                variant={{ priority: 'high' }}
                type="button"
                onClick={handleSubmit}
              >
                Next
              </Button>
            </div>
          </Form>
        </>
      )}
    </Formik>
  );
};

export default StepOne;
